module.exports = __webpack_public_path__ + "img/gameIcon.57454986.png";